import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeaturePanelStyles {
  root?: IStyle;
}

export interface IEditFeaturePanelClassNames {
  root: string;
}

export const editFeaturePanelStylesDefault = (_theme: IH2OTheme): Partial<IEditFeaturePanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
